
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beruf",
      function () {
        return require("private-next-pages/beruf/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beruf"])
      });
    }
  